<ngx-ui-loader *ngIf="isTrue"></ngx-ui-loader>
<router-outlet></router-outlet>
